import { render } from "./Page.vue?vue&type=template&id=e3e18e7a"
import script from "./Page.vue?vue&type=script&lang=ts"
export * from "./Page.vue?vue&type=script&lang=ts"
script.render = render

export default script